<template>
  <div class="event_managing_add">
    <div style="padding: 0px 20px;height: 100%">
      <div class="search">
        <div class="search_box">
          <button @click="goback()">< 返回节目管理列表</button>
        </div>
      </div>
      <label class="ad_name">节目名称:<input type="text" v-model="name" placeholder="请输入节目名称">
        <button class="publish" @click="save">保存</button>
      </label>
      <div :class='["information_box","light_border"]'
           :style="[{width:'100%'},{height:'calc(100% - 192px)'},{'margin':'20px 0'}]">
        <div class="border_top_left"></div>
        <div class="border_top_right"></div>
        <div class="border_bottom_left"></div>
        <div class="border_bottom_right"></div>
        <div class="h_light_right" :style="{top:'95px'}"></div>
        <div class="information_content">
          <div class="table_box">
            <h1>A面屏：
              <button class="add" @click="AddResource_A=!AddResource_A"><span class="icon-1"></span>添加资源</button>
              <button class="delete" @click="A_BatchesDelete"><span class="icon-1"></span>批量删除</button>
            </h1>
            <div class="table_content">
              <table>
                <thead>
                <tr>
                  <th width="50px"><input type="checkbox" name="A_All" @click="ACheckedAll()"></th>
                  <th style="padding-left: 30px;width: 50px">序号</th>
                  <th>资源名称</th>
                  <th>停留时长</th>
                  <th>入场动作</th>
                  <th>出场动作</th>
                  <th>入场速度</th>
                  <th>出场速度</th>
                  <th>操作</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,index) in A_List">
                  <td width="50px"><input type="checkbox" name="A" @click="ACheckedOne(index)"></td>
                  <td style="padding-left: 30px;width: 50px">{{index+1}}</td>
                  <td style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis">{{item.name}}</td>
                  <td>{{item.duration}}</td>
                  <td v-for="item2 in action" v-if="item.in_effect===item2.value.toString()">{{item2.name}}</td>
                  <td v-for="item2 in action" v-if="item.out_effect===item2.value.toString()">{{item2.name}}</td>
                  <td>{{item.in_speed}}</td>
                  <td>{{item.out_speed}}</td>
                  <td class="table_btn_box">
                    <!--                    <button class="table_btn">编辑</button>-->
                    <button class="table_btn" @click="A_ListDev(index)">删除</button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <p>共{{A_List.length}}条记录</p>
          </div>
          <div class="table_box">
            <h1>
              B面屏：
              <button class="add" @click="AddResource_B=!AddResource_B"><span class="icon-1"></span>添加资源</button>
              <button class="delete"  @click="B_BatchesDelete"><span class="icon-1"></span>批量删除</button>
            </h1>
            <div class="table_content">
              <table>
                <thead>
                <tr>
                  <th width="50px"><input type="checkbox" name="B_All" @click="BCheckedAll()"></th>
                  <th style="padding-left: 30px;width: 50px">序号</th>
                  <th>资源名称</th>
                  <th>
                    <select>
                      <option value="全部">&nbsp;&nbsp;&nbsp;全部</option>
                      <option value="已发布">已发布</option>
                      <option value="未发布">未发布</option>
                    </select>
                  </th>
                  <th>作者</th>
                  <th>创建时间</th>
                  <th>上次播放时间</th>
                  <th>已发布到</th>
                  <th>操作</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,index) in B_List">
                  <td width="50px"><input type="checkbox" name="B" @click="BCheckedOne(index)"></td>
                  <td style="padding-left: 30px;width: 50px">{{index+1}}</td>
                  <td style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis">{{item.name}}</td>
                  <td>{{item.duration}}</td>
                  <td v-for="item2 in action" v-if="item.in_effect===item2.value.toString()">{{item2.name}}</td>
                  <td v-for="item2 in action" v-if="item.out_effect===item2.value.toString()">{{item2.name}}</td>
                  <td>{{item.in_speed}}</td>
                  <td>{{item.out_speed}}</td>
                  <td class="table_btn_box">
                    <!--                    <button class="table_btn">编辑</button>-->
                    <button class="table_btn" @click="B_ListDev(index)">删除</button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <p>共{{B_List.length}}条记录</p>
          </div>

        </div>
      </div>
      <!--        表格-->


      <!--      A面添加资源-->
      <transition name="fade">
        <div class="mark" v-if="AddResource_A">
          <div class="mark_close" @click="AddResource_A=!AddResource_A"></div>
          <div :class='["information_box","light_border","weather_box"]'
               :style="[{width:'700px'},{'margin-top':'0px'}]">
            <div class="border_top_left"></div>
            <div class="border_top_right"></div>
            <div class="border_bottom_left"></div>
            <div class="border_bottom_right"></div>
            <div class="h_light_right" :style="{top:'95px'}"></div>
            <div class="information_content issue_search_box model">
              <h1>
                A面屏添加资源
              </h1>
              <div style="padding: 0 20px;box-sizing: border-box">
                <el-form ref="A_Addform" :model="A_Addform" label-width="80px" :rules="rules">
                  <el-form-item label="选择资源" prop="resource">
                    <el-select v-model="A_Addform.resource" placeholder="请选择资源">
                      <el-option v-for="(item,index) in ResourceData" :key="index" :label="item.name"
                                 :value="item.id+','+item.file_url+','+item.type+','+item.name"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="停留时长" prop="StayTime">
                    <el-input type="number" v-model="A_Addform.StayTime" placeholder="请输入(单位:ms)"></el-input>
                  </el-form-item>
                  <el-form-item label="入场速度" prop="FadeInSpeed">
                    <el-select v-model="A_Addform.FadeInSpeed" placeholder="请选择入场速度">
                      <el-option label="0.5秒" value="500"></el-option>
                      <el-option label="1秒" value="1000"></el-option>
                      <el-option label="2秒" value="2000"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="出场速度" prop="FadeOutSpeed">
                    <el-select v-model="A_Addform.FadeOutSpeed" placeholder="请选择出场速度">
                      <el-option label="0.5秒" value="500"></el-option>
                      <el-option label="1秒" value="1000"></el-option>
                      <el-option label="2秒" value="2000"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="入场动作" prop="FadeInAction">
                    <el-select v-model="A_Addform.FadeInAction" placeholder="请选择入场动作">
                      <el-option v-for="(item,index) in action" :key="index" :label="item.name" :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="出场动作" prop="FadeOutAction">
                    <el-select v-model="A_Addform.FadeOutAction" placeholder="请选择出场动作">
                      <el-option v-for="(item,index) in action" :key="index" :label="item.name" :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>

                </el-form>
              </div>
              <div class="sbt_box">
                <button :class='["add_btn","delete","icon_btn","clearborder"]' @click="resetForm('A_Addform')">取消
                </button>
                <button :class='["add_btn","add","icon_btn","clearborder"]' @click="A_save('A_Addform')">保存</button>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <!--      B面添加资源-->
      <transition name="fade">
        <div class="mark" v-if="AddResource_B">
          <div class="mark_close" @click="AddResource_B=!AddResource_B"></div>
          <div :class='["information_box","light_border","weather_box"]'
               :style="[{width:'700px'},{'margin-top':'0px'}]">
            <div class="border_top_left"></div>
            <div class="border_top_right"></div>
            <div class="border_bottom_left"></div>
            <div class="border_bottom_right"></div>
            <div class="h_light_right" :style="{top:'95px'}"></div>
            <div class="information_content issue_search_box model">
              <h1>
                B面屏添加资源
              </h1>
              <div style="padding: 0 20px;box-sizing: border-box">
                <el-form ref="B_Addform" :model="B_Addform" label-width="80px" :rules="rules">
                  <el-form-item label="选择资源" prop="resource">
                    <el-select v-model="B_Addform.resource" placeholder="请选择资源">
                      <el-option v-for="(item,index) in ResourceData" :key="index" :label="item.name"
                                 :value="item.id+','+item.file_url.toString()+','+item.type+','+item.name"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="停留时长" prop="StayTime">
                    <el-input type="number" v-model="B_Addform.StayTime" placeholder="请输入(单位:ms)"></el-input>
                  </el-form-item>
                  <el-form-item label="入场速度" prop="FadeInSpeed">
                    <el-select v-model="B_Addform.FadeInSpeed" placeholder="请选择入场速度">
                      <el-option label="0.5秒" value="500"></el-option>
                      <el-option label="1秒" value="1000"></el-option>
                      <el-option label="2秒" value="2000"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="出场速度" prop="FadeOutSpeed">
                    <el-select v-model="B_Addform.FadeOutSpeed" placeholder="请选择出场速度">
                      <el-option label="0.5秒" value="500"></el-option>
                      <el-option label="1秒" value="1000"></el-option>
                      <el-option label="2秒" value="2000"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="入场动作" prop="FadeInAction">
                    <el-select v-model="B_Addform.FadeInAction" placeholder="请选择入场动作">
                      <el-option v-for="(item,index) in action" :key="index" :label="item.name" :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="出场动作" prop="FadeOutAction">
                    <el-select v-model="B_Addform.FadeOutAction" placeholder="请选择出场动作">
                      <el-option v-for="(item,index) in action" :key="index" :label="item.name" :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>

                </el-form>
              </div>
              <div class="sbt_box">
                <button :class='["add_btn","delete","icon_btn","clearborder"]' @click="resetForm('B_Addform')">取消
                </button>
                <button :class='["add_btn","add","icon_btn","clearborder"]' @click="B_save('B_Addform')">保存</button>
              </div>
            </div>
          </div>
        </div>
      </transition>

      <transition name="fade" v-on:leave="leave">
        <div class="mark" v-if="msg_show">
          <div class="mark_close" @click="msg_show=!msg_show"></div>
          <div :class='["information_box","light_border","weather_box"]'
               :style="[{width:'500px'},{'margin-top':'0px'}]">
            <div class="border_top_left"></div>
            <div class="border_top_right"></div>
            <div class="border_bottom_left"></div>
            <div class="border_bottom_right"></div>
            <div class="information_content issue_search_box model">
              <div id="msg">{{message}}</div>
            </div>
          </div>
        </div>
      </transition>


    </div>
  </div>
</template>

<script>
  export default {
    name: "event_managing_add",
    data() {
      return {

        LedID:"",


        search: [
          {
            title: '选择项目',
            select: [
              {option: "请选择项目"},
              {option: "项目1"},
            ]
          }
        ],
        refresh: false,

        msg_show: false,
        message: '',
        action: [
          {value:0, name:"无特效"},
          {value:1, name:"随机"},
          {value:2, name:"左覆盖"},
          {value:3, name:"右覆盖"},
          {value:4, name:"上覆盖"},
          {value:5, name:"下覆盖"},
          {value:6, name:"左上角覆盖(斜线)"},
          {value:7, name:"右上角覆盖(斜线)"},
          {value:8, name:"左下角(斜线)"},
          {value:9, name:"右下角(斜线)"},
          {value:10, name:"左上角覆盖(直线)"},
          {value:11, name:"右上角覆盖(直线)"},
          {value:12, name:"左下角(直线)"},
          {value:13, name:"右下角(直线)"},
          {value:14, name:"水平百叶"},
          {value:15, name:"垂直百叶"},
          {value:16, name:"左右对开"},
          {value:17, name:"上下对开"},
          {value:18, name:"左右闭合"},
          {value:19, name:"上下闭合"},
          {value:20, name:"上移"},
          {value:21, name:"下移"},
          {value:22, name:"左移"},
          {value:23, name:"右移"},
          {value:24, name:"左上角移"},
          {value:25, name:"右上角移"},
          {value:26, name:"左下角移"},
          {value:27, name:"右下角移"},
          {value:28, name:"马赛克(小)"},
          {value:29, name:"马赛克(中)"},
          {value:30, name:"马赛克(大)"},
          {value:31, name:"渐变"},
          {value:32, name:"右旋360"},
          {value:33, name:"左旋360"},
          {value:34, name:"右旋180"},
          {value:35, name:"左旋180"},
          {value:36, name:"右旋90"},
          {value:37, name:"左旋90"},
          {value:38, name:"由小变大(中间)"},
          {value:39, name:"由小变大(左上)"},
          {value:40, name:"由小变大(右上)"},
          {value:41, name:"由小变大(右下)"},
          {value:42, name:"由小变大(左下)"},
          {value:43, name:"中间向四周(矩形)"},
          {value:44, name:"四周向中间(矩形)"},
          {value:45, name:"中间向四周(菱形)"},
          {value:46, name:"四周向中间(菱形)"},
          {value:47, name:"中间向四周(十字)"},
          {value:48, name:"四周向中间(十字)"},
        ],
        ResourceData: [],//资源列表
        //添加资源 a面
        AddResource_A: false,
        A_Addform: {
          value:'',
          id:'',
          resource: '',
          StayTime: '',
          FadeInSpeed: '',
          FadeOutSpeed: '',
          FadeInAction: '',
          FadeOutAction: '',
        },
        AddResource_B: false,
        B_Addform: {
          value:'',
          id:'',
          resource: '',
          StayTime: '',
          FadeInSpeed: '',
          FadeOutSpeed: '',
          FadeInAction: '',
          FadeOutAction: '',
        },
        rules: {
          resource: [
            {required: true, message: '请选择资源', trigger: 'change'}
          ],
          StayTime: [
            {required: true, message: '停留时长不能为空'},
          ],
          FadeInSpeed: [
            {required: true, message: '请选择入场速度', trigger: 'change'}
          ],
          FadeOutSpeed: [
            {required: true, message: '请选择出场速度', trigger: 'change'}
          ],
          FadeInAction: [
            {required: true, message: '请选择入场动作', trigger: 'change'}
          ],
          FadeOutAction: [
            {required: true, message: '请选择出场动作', trigger: 'change'}
          ],
        },
        //上传的DATA
        name: '',//节目名称
        resource_a:[],
        resource_b:[],
        A_List: [],
        B_List: [],
        //多选
        AisCheckedAll:false,
        AisCheckIndex:[],
        BisCheckedAll:false,
        BisCheckIndex:[],
      }
    },
    methods: {
      InitLeftMenu: function () {
        this.$emit('getMessage', '4', '2');
      },
      goback: function () {
        this.$router.go(-1)
      },
      leave: function () {
        if (this.refresh) {
          this.$router.push({path: '/monitoring/MsgEvent_managing'})
        }
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
        this.AddResource_A = false;
        this.AddResource_B = false;
      },
      //A屏多选和单选
      ACheckedOne(id) {
        let idIndex = this.AisCheckIndex.indexOf(id);
        if (idIndex >= 0) {
          // 如果已经包含了该id, 则去除(单选按钮由选中变为非选中状态)
          this.AisCheckIndex.splice(idIndex, 1)
        } else {
          // 选中该checkbox
          this.AisCheckIndex.push(id)
        }
        console.log(this.AisCheckIndex);
      },
      ACheckedAll() {
        this.AisCheckedAll = !this.AisCheckedAll;
        if (this.AisCheckedAll) {
          // 全选时
          this.AisCheckIndex = [];
          for (var i = 0;i<this.A_List.length;i++){
            this.AisCheckIndex.push(i);
          }
          $('input[name="A"]').each(function () {
            $(this).prop("checked", true);
          });
        } else {
          this.AisCheckIndex = [];
          $('input[name="A"]').each(function () {
            $(this).prop("checked", false);
          });
        }
        console.log(this.AisCheckIndex);
      },
      A_BatchesDelete(){
        for (let i = this.AisCheckIndex.length-1;i>=0;i--){
          let flag = this.AisCheckIndex[i];
          console.log(flag);
          this.A_List.splice(flag, 1);
        }
        if ($('input[name="A_All"]').is(':checked')){
          $('input[name="A_All"]').prop("checked", false);
        }
        this.AisCheckIndex = [];
        $('input[name="A"]').prop("checked", false);
        console.log(this.AisCheckIndex);
        console.log(this.A_List);
      },
      //B屏多选和单选
      BCheckedOne(id) {
        let idIndex = this.BisCheckIndex.indexOf(id);
        if (idIndex >= 0) {
          // 如果已经包含了该id, 则去除(单选按钮由选中变为非选中状态)
          this.BisCheckIndex.splice(idIndex, 1)
        } else {
          // 选中该checkbox
          this.BisCheckIndex.push(id)
        }
        console.log(this.BisCheckIndex);
      },
      BCheckedAll() {
        this.BisCheckedAll = !this.BisCheckedAll;
        if (this.BisCheckedAll) {
          // 全选时
          this.BisCheckIndex = [];
          for (var i = 0;i<this.B_List.length;i++){
            this.BisCheckIndex.push(i);
          }
          $('input[name="B"]').each(function () {
            $(this).prop("checked", true);
          });
        } else {
          this.BisCheckIndex = [];
          $('input[name="B"]').each(function () {
            $(this).prop("checked", false);
          });
        }
        console.log(this.BisCheckIndex);
      },
      B_BatchesDelete(){
        for (let i = this.BisCheckIndex.length-1;i>=0;i--){
          let flag = this.BisCheckIndex[i];
          this.B_List.splice(flag, 1);
        }
        if ($('input[name="B_All"]').is(':checked')){
          $('input[name="B_All"]').prop("checked", false);
        }
        this.BisCheckIndex = [];
        $('input[name="B"]').prop("checked", false);
      },

      //保存
      A_save: function (formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let SplitData = this.A_Addform.resource.split(",");
            let Data = {};
            let i = SplitData[1].indexOf("F");
            if (SplitData[2]=="IMG") {
              Data.type='2'
            }else {
              Data.type='3'
            }
            Data.name = SplitData[3];
            Data.file_name=SplitData[1].substr(i);
            Data.duration=this.A_Addform.StayTime;
            Data.in_speed=this.A_Addform.FadeInSpeed;
            Data.out_speed=this.A_Addform.FadeOutSpeed;
            Data.in_effect=this.A_Addform.FadeInAction.toString();
            Data.out_effect=this.A_Addform.FadeOutAction.toString();
            this.A_List.push(Data);
            this.resource_a.push(SplitData[0]);
            this.AddResource_A = !this.AddResource_A;
            this.$refs[formName].resetFields();
          } else {
            return false;
          }
        });
      },
      B_save: function (formName) {
        this.$refs[formName].validate((valid) => {

          if (valid) {
            let SplitData = this.B_Addform.resource.split(",");
            let Data = {};
            let i = SplitData[1].indexOf("F");
            if (SplitData[2]=="IMG") {
              Data.type='2'
            }else {
              Data.type='3'
            }
            Data.name = SplitData[3];
            Data.file_name=SplitData[1].substr(i);
            Data.duration=this.B_Addform.StayTime;
            Data.in_speed=this.B_Addform.FadeInSpeed;
            Data.out_speed=this.B_Addform.FadeOutSpeed;
            Data.in_effect=this.B_Addform.FadeInAction.toString();
            Data.out_effect=this.B_Addform.FadeOutAction.toString();
            this.B_List.push(Data);
            this.resource_b.push(SplitData[0]);
            this.AddResource_B = !this.AddResource_B;
            this.$refs[formName].resetFields();
          } else {
            return false;
          }
        });
      },
      //删除
      A_ListDev: function (index) {
        this.A_List.splice(index, 1);
        this.AisCheckIndex.splice(index,1);
        this.resource_a.splice(index, 1);
        $('input[name="A"]').prop("checked", false);
      },
      B_ListDev: function (index) {
        this.B_List.splice(index, 1);
        this.BisCheckIndex.splice(index,1);
        this.resource_b.splice(index, 1);
        $('input[name="B"]').prop("checked", false);
      },
      //保存
      save: function () {
        if (this.name != '') {
          fetch("/api/v1/led/program/add", {
            method: 'post',
            body: JSON.stringify({
              "project": "f899dfb4a9094ac48fbb27b64021d5e1",
              "resource_a":this.resource_a,
              "resource_b":this.resource_b,
              "name":this.name,
              "items":{
                "a":this.A_List,
                "b":this.B_List,
              }
            })
          }).then(result=>{
            return result.json()
          }).then(data=>{
            console.log(data)
            if (data.code==="200"){
              this.msg_show = !this.msg_show;
              this.message = '保存成功';
              this.refresh = true
            }else if (data.code=="2000"){
              this.msg_show = !this.msg_show;
              this.message = '该节目名称已存在';
            }else {
              this.msg_show = !this.msg_show;
              this.message = '保存异常，请重试';
            }
          }).catch(error=>{
            this.msg_show = !this.msg_show;
            this.message = '网络错误，请重试';
            throw error
          });
        }else {
          this.msg_show = !this.msg_show;
          this.message = '请输入节目名称';
        }
      }
    },
    created() {
      this.InitLeftMenu();
      fetch("/api/v1/led/resource/list", {
        method: 'post',
        body: JSON.stringify({
          // "project_id": "f899dfb4a9094ac48fbb27b64021d5e1",
          "page_start": 0,
          "page_size": 10,
        })
      })
        .then(result => {
          return result.json();//解析流
        })
        .then(data => {
          console.log(data.data);
          this.ResourceData = data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    mounted() {

    }
  }
</script>

<style scoped>
  .event_managing_add {
    width: 100%;
    height: 100%;
  }

  .search {
    width: 100%;
    height: 58px;
    padding: 20px 0 0;
  }

  .search_box {
    width: 100%;
    height: 100%;
    margin-right: 10px;
    background: #16518d;
    border-radius: 6px;
    float: left;
    display: flex;
    align-items: center;
    padding: 0 20px;
    box-sizing: border-box;
    position: relative;
  }

  .search_box > button {
    font-size: 20px;
    color: #FFFFFF;
    border: none;
    background: transparent;
    font-weight: bold;
    outline: none;
  }

  .ad_name {
    width: 100%;
    height: 32px;
    line-height: 32px;
    color: #FFFFFF;
    font-size: 20px;
    margin: 20px 0;
  }

  .ad_name input {
    margin-left: 5px;
    color: #FFFFFF;
    text-align: center;
    background: #16518d;
    border: 1px solid #2d73ba;
    border-radius: 4px;
    font-size: 18px;
    outline: none;
  }

  .ad_name > button {
    float: right;
    width: 90px;
    border: none;
    border-radius: 4px;
    font-size: 16px;
    outline: none;
  }

  input::-webkit-input-placeholder {
    color: #ffffff;
  }

  input::-moz-placeholder { /* Mozilla Firefox 19+ */
    color: #ffffff;
  }

  input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    color: #ffffff;
  }

  input:-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: #ffffff;
  }

  .green {
    background: #21b868;
    color: #FFFFFF;
  }

  .green:active {
    background: #15a95a;
  }

  .add_btn_box {
    /*width: 370px;*/
    padding: 10px;
    position: absolute;
    right: 0px;
  }

  .add {
    background: #7aafeb;
    color: #FFFFFF;
    box-shadow: 0px 3px 0px #3574ba;
  }

  .add:active {
    background: #6ca3e2;
  }

  .publish {
    background: #21b868;
    color: #FFFFFF;
    box-shadow: 0px 3px 0px #188d4f;
  }

  .publish:active {
    background: #188d4f;
  }

  .delete {
    background: #f2ae4d;
    color: #FFFFFF;
    box-shadow: 0px 3px 0px #dc8509;
  }

  .delete:active {
    background: #e7a342;
  }


  .table_box {
    width: 100%;
    height: 50%;
    padding: 20px;
    box-sizing: border-box;
  }

  .table_box > h1 {
    height: 28px;
    line-height: 28px;
    color: #00f0ff;
    font-size: 20px;
    padding: 0 20px;
    margin-bottom: 0;
    box-sizing: border-box;
  }

  .table_box > h1 > button {
    width: 90px;
    height: 28px;
    font-size: 16px;
    border: none;
    outline: none;
    margin-left: 10px;
    border-radius: 3px;
  }

  .table_box > p {
    text-align: right;
    padding: 0 20px;
    box-sizing: border-box;
    color: #FFFFFF;
    border: 1px solid #0e457e;
    font-size: 14px;
    line-height: 30px;
    height: 30px;
    display: block;
    width: 100%;
    margin-bottom: 0;
  }

  .table_content {
    width: 100%;
    height: calc(100% - 95px);
    padding: 20px 0;
  }

  .table_content table {
    width: 100%;
    height: 100%;
    border: 1px solid #094b8e;
  }

  .table_content table thead tr {
    height: 40px;
    border-bottom: 1px solid #094b8e;
  }

  .table_content table thead tr th {
    color: #FFFFFF;
    font-size: 16px;
  }

  .table_content table tbody {
    display: block;
    height: 100%;
    overflow-y: scroll;
  }

  .table_content table thead tr,
  .table_content table tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
    text-align: center;
  }

  .table_content table tbody tr {
    background: #16518d;
    border-bottom: 1px solid #094b8e;
  }

  .table_content table select {
    border: none;
    background: transparent;
    color: #FFFFFF;
    font-weight: bold;
    outline: none;
  }

  .table_content table option {
    color: #000000;
  }

  .table_content table tbody tr:nth-child(2n+0) {
    background: #11406f;
  }

  .table_content table tbody tr td {
    height: 40px;
    color: #FFFFFF;
  }


  .table_content table thead {
    width: calc(100% - 1em);
  }

  .table_paging {
    height: 60px;
    width: 100%;
    display: flex;
    align-items: center;
    border: 1px solid #105ba8;
    border-radius: 6px;
  }

  .table_paging > p {
    width: 100%;
    height: 30px;
    line-height: 30px;
    text-align: right;
    margin-bottom: 0;
    color: #c1c2c6;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 10px;
  }

  .table_paging > p > button {
    margin: 0 8px;
    width: 10px;
    height: 16px;
    border: none;
    outline: none;
  }

  .table_btn {
    color: #95bee5;
    background: transparent;
    border: 1px solid #95bee5;
    outline: transparent;
    padding: 5px 20px;
    border-radius: 6px;
  }

  .el-form-item {
    width: 50%;
    float: left;
    display: flex;
    align-items: center;
  }
</style>
<style>
  .el-form-item__content {
    margin-left: 0 !important;
  }

  .el-form-item__label {
    color: #FFFFFF;
    margin-bottom: 0;
  }

  .el-input__inner {
    padding-right: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/03Monitoring/5_msg/event_managing_add.vue